import { render, staticRenderFns } from "./ScreenObstetricaComDopplerEEcocardiodoppler.vue?vue&type=template&id=c5be5b80&scoped=true&"
import script from "./ScreenObstetricaComDopplerEEcocardiodoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetricaComDopplerEEcocardiodoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetricaComDopplerEEcocardiodoppler.vue?vue&type=style&index=0&id=c5be5b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be5b80",
  null
  
)

export default component.exports